import { Instant } from "@js-joda/core";
import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { T } from "services/lang/LanguageService";
import { useDisplayTimezone } from "hooks/useTimezone";
import { formatDisplayDatetime } from "utils/time-utils";
import { ILastKnownValueTimeMomentProps } from "./LastKnownValueTimeMomentTypes";

export default function LastKnownValueTimeMoment(props: ILastKnownValueTimeMomentProps) {
  const displayTz = useDisplayTimezone();
  const [instant, setInstant] = useState<Instant | undefined>();

  const dateFormat = props.dateFormat || "yyyy-MM-dd HH:mm:ss";
  const text = props.customText || "";

  const { data, isLoading } = useGetRecentData([props.identifier], {
    options: {
      refetchInterval: props.updateFrequency ? props.updateFrequency * 1000 : 5000,
    },
  });

  useEffect(() => {
    if (data && data[0]?.data[0]?.key) {
      const lastValueTime = data[0]?.data[0]?.key;
      setInstant(Instant.parse(lastValueTime));
    } else {
      setInstant(undefined);
    }
  }, [data]);

  if (isLoading) {
    return <ProgressSpinner />;
  }

  if (!instant) {
    return <div>{T("message.this-dataset-has-no-values")}</div>;
  }

  return (
    <div className="last-value-time-indicator" style={props.style as React.CSSProperties}>
      {text.length > 0 ? `${text}: ` : ""}
      {formatDisplayDatetime(instant, displayTz, dateFormat)}
    </div>
  );
}
